//@ts-nocheck
import {
	IonPage,
	IonHeader,
	IonToolbar,
	IonButtons,
	IonBackButton,
	IonTitle,
	IonContent,
	useIonViewDidEnter,
	useIonViewWillLeave
} from '@ionic/react';
import {arrowBack} from 'ionicons/icons';
import React, {useEffect, useState} from 'react';
import Webix from '../components/Webix';
import useAuth from '../hooks/useAuth';
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";

const reports = (window as any).reports;
const webix = (window as any).webix;
const $$ = (window as any).$$;

function debounce(func: () => void, timeout = 1500) {
    let timer: NodeJS.Timeout;
    return (...args: []) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            //@ts-ignore
            func.apply(this, args);
        }, timeout);
    };
}

let typeToSort = {
    number: "int",
    date: "date",
    text: "string",
    boolean: "number",
    picklist: "text",
    reference: "text",
};

let __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (let s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (let p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function showWebixError(errorMsg: string) {
	webix.alert({
		title: "Error",
		text: errorMsg,
		type: "alert-error",
		id: "webixError"
	});
}

class MyBackend extends reports.services.Backend {
	getData(config: { id: any; query: any; columns: any; joins: any; limit: any; group: any; sort: any; buckets: any; data: string; offset: number; }) {
		$$("reports").showProgress({type: "top"});
		let query = config.query, id = config.id, offset = config.offset, columns = config.columns,
			joins = config.joins, limit = config.limit, group = config.group, sort = config.sort,
			buckets = config.buckets;
		return webix
			.ajax()
			.post(this._url + "api/objects/" + config.data + "/data", {
				query,
				columns,
				joins,
				limit,
				offset,
				sort,
				group,
				buckets,
				id
			}).then((a: any) => {
				$$("reports").hideProgress();
				return a.json();
			});
	}

	getModules(config: any) {
		return webix.ajax(this._url + "api/modules").then((a: any) => {
			$$("reports").hideProgress();
			return a.json().map((x: any) => {
				let text = JSON.parse(x.text);
				text.id = x.id;
				return {...x, text: JSON.stringify(text)}
			});
		});
	};

	getExport(config: { id: any; query: any; columns: any; joins: any; limit: any; group: any; sort: any; buckets: any; data: string; offset: number; columnNames: string[]; name: string }) {
		let query = config.query, id = config.id, columns = config.columns, joins = config.joins, group = config.group,
			sort = config.sort, buckets = config.buckets, columnNames = config.columnNames, name = config.name;
		return webix
			.ajax()
			.post(this._url + "api/objects/" + config.data + "/export", {
				query,
				columns,
				joins,
				sort,
				limit: "",
				offset: "",
				group,
				buckets,
				id,
				columnNames,
				name
			}).then((a: any) => {
				return a.json();
			});
	}

	getRoles() {
		return webix.ajax(process.env.REACT_APP_USERMANAGER_ENDPOINT + "roles").then((a: any) => {
			return a.json();
		});
	}

	getSchema(config: any) {
		return webix.ajax(this._url + "api/meta").then((a: any) => {
			return a.json();
		});
	};

	updateModule = function (id, data) {
		return webix
			.ajax()
			.put(this._url + "api/modules/" + id, data)
			.then(function (a) {
				return a.json();
			}).catch(function (error) {
				console.error(error);
				if (error?.responseText !== undefined) {
					showWebixError(webix.template.escape(error.responseText));
				} else {
					showWebixError('An unknown error occurred');
				}
			});
	};

	addModule = function (data) {
		return webix
			.ajax()
			.post(this._url + "api/modules", data)
			.then(function (a) {
				return a.json();
			}).catch(function (error) {
				console.error(error);
				if (error?.responseText !== undefined) {
					showWebixError(webix.template.escape(error.responseText));
				} else {
					showWebixError('An unknown error occurred');
				}
			});
	};

	addQuery = function (data) {
		return webix
			.ajax()
			.post(this._url + "api/queries", data)
			.then(function (a) {
				return a.json();
			}).catch(function (error) {
				console.error(error);
				if (error?.responseText !== undefined) {
					showWebixError(webix.template.escape(error.responseText));
				} else {
					showWebixError('An unknown error occurred');
				}
			});
	};
}

//@ts-ignore
class MyLocal extends reports.services.Local {
    getDataConfig = function (module: any) {
        return {
            id: module.id,
            data: module.data,
            query: module.query,
            columns: module.columns.map(function (a: any) {
                return a.id;
            }).sort(),
            joins: module.joins,
            sort: module.sort,
            group: module.group && module.group.by
                ? module.group.by.map(function (a: any) {
                    return (a.mod ? a.mod + "." : "") + a.id;
                })
                : "",
            buckets: module.buckets,
            limit: module.limit,
            offset: module.offset
        };
    };
    getLinkedModels = function (base, onlyNew, noOrigin) {
        let out = [];
        let refs = this.getRefs();
        for (let i = 0; i < base.length; i++) {
            let sid = base[i];
            if (!refs[sid])
                continue;
            refs[sid].forEach(function (ref) {
                if (onlyNew && base.indexOf(ref.tid) != -1)
                    return;
                out.push(__assign({}, ref));
            });
        }
        return out;
    };
}

//@ts-ignore
class CustomColumnSetup extends reports.views["editor/structure/column"] {
    config() {
        let ui = super.config();
        ui.rows.inputs[1].options.push({id: "date", value: "Date"});
        return ui;
    }
}

function handler(view) {
	return {
		attachEvent: function (key, handler) {
			webix.UIManager.addHotKey(key, handler, view);
			return { key: key, handler: handler };
		},
		detachEvent: function (_a) {
			let key = _a.key, handler = _a.handler;
			return webix.UIManager.removeHotKey(key, handler, view);
		},
	};
}

class CustomToolbar extends reports.views["toolbar"] {
	init() {
		let _this = this;
		this.State = this.app.getParam("state", true);
		this.on(this.State.$changes, "module", function (mod) {
			if (mod) {
				if (typeof mod.name != "undefined")
					_this.$$("name").setValue(webix.template.escape(mod.name));
				else if (_this.State.moduleId)
					_this.app
						.getService("local")
						.getModule(_this.State.moduleId)
						.then(function (module) {
							_this.$$("name").setValue(webix.template.escape(module.name));
						});
			} else {
				_this.$$("name").setValue("");
			}
		});
		this.on(this.State.$changes, "saved", function (v) {
			let name = _this.$$("name").$view;
			if (v) {
				_this.$$("save").disable();
				name.classList.remove("webix_rpt_not_saved");
			} else {
				_this.$$("save").enable();
				name.classList.add("webix_rpt_not_saved");
			}
		});
		this.on(this.State.$changes, "mode", function () {
			return _this.SetVisibleButtons();
		});
		this.on(this.State.$changes, "moduleId", function () {
			return _this.SetVisibleButtons();
		});
		this.on(this.State.$changes, "readonly", function () {
			return _this.SetVisibleButtons();
		});
		this.on(handler(), "ctrl+e", function () {
			_this.app.callEvent("onMenuAction", [null, "edit"]);
			return false;
		});
		this.on(handler(), "ctrl+s", function () {
			_this.app.callEvent("saveModule", []);
			return false;
		});
		this.on(handler(), "ctrl+l", function () {
			_this.app.callEvent("showModules", [true]);
			return false;
		});
	};

	config() {
		let ui = super.config();
		let app = this.app;
		const clientProp = new URLSearchParams(window.location.search).get("client");
		if (!clientProp) { // embedded version in AMS doesn't show client switch and Schema Config
			ui.elements = [{
				view: "richselect",
				value: localStorage.getItem('currentClient') ? localStorage.getItem('currentClient') : 'ent',
				id: "clientChange",
				options: [{id: "aw", value: "Assist"}, {id: "ent", value: "Entouch"}],
				width: 140,
				on: {
					onChange: (newValue: string) => {
						localStorage.setItem('currentClient', newValue);
						window.location.reload();
					}
				}
			}, ...ui.elements, {
				view: "button",
				value: "Schema Config",
				width: 150,
				click: function () {
					app.getService("backend").getSchema().then((res: any) => {
						let mappedData = res.models.map(model => {
							let newModel = {...model, open: false, $level: 1};
							newModel.data = model.data.map(child => {
								return {...child, id: `${model.id}.${child.id}`, $level: 2};
							});
							return newModel;
						});
						for (let model of mappedData) {
							for (let item of model.data) {
								item.filter = item.filter === true || item.filter === "true" || item.filter === 1;
								item.hierarchy = item.hierarchy === true || item.hierarchy === "true" || item.hierarchy === 1;
								item.label = item.label === true || item.label === "true" || item.label === 1;
								item.key = item.key === true || item.key === "true" || item.key === 1;
							}
						}

						mappedData = mappedData.sort((module1, module2) => module1.name.localeCompare(module2.name));

						webix.ui({
							view: "window",
							id: "my_window",
							width: 1300,
							height: 600,
							position: "center",
							resize: true,
							move: true,
							modal: true,
							head: {
								view: "toolbar",
								cols: [
									{view: "label", label: "Schema Config"},
									{
										view: "button",
										label: 'Close',
										width: 70,
										align: 'right',
										click: "$$('my_window').close();"
									}
								]
							},
							body: {
								rows: [{
									scroll: "y",
									view: "form",
									elements: [
										{
											view: "treetable",
											id: "my_treetable",
											editable: true,
											autowidth: true,
											scrollY: true,
											fixedRowHeight: false,
											css: 'schema_treetable',
											columns: [
												{
													id: "id",
													header: "ID",
													fillspace: true,
													minWidth: 300,
													template: function (obj, common) {
														let ids = obj.id.split('.');
														let content = common.treetable(obj, common) + " " + ids[ids.length - 1];
														return "<div title='" + ids[ids.length - 1] + "' class='overflow-ellipsis'>" + content + "</div>";
													}
												},
												{
													id: "name",
													header: "Name",
													minWidth: 200,
													fillspace: true,
													template: function (obj) {
														return "<div title='" + obj.name + "' class='overflow-ellipsis'>" + obj.name + "</div>";
													}
												},
												{
													id: "type",
													header: "Type",
													template: function (obj) {
														if (obj.$level === 1) {  // if it is a parent row
															return ""; // empty cell
														} else {  // if it is a child row
															return "<div>" + obj.type + "</div>" || "";
														}
													},
												},
												{
													id: "filter",
													header: "Filter",
													fillspace: true,
													template: function (obj) {
														if (obj.$level === 1) {
															return "";
														} else {
															return "<div>" + (obj.filter ? "Yes" : "No") + "</div>";
														}
													},
												},
												{
													id: "ref",
													header: "Reference",
													fillspace: true,
													template: function (obj, common) {
														if (obj.$level === 2) {
															let content = obj.ref;
															return "<div title='" + content + "' class='overflow-ellipsis'>" + content + "</div>";
														} else {
															return ""; // return empty string for other levels
														}
													}
												},
												{
													id: "label",
													header: "Label",
													fillspace: true,
													template: function (obj) {
														if (obj.$level === 1) {
															return "";
														} else {
															return "<div>" + (obj.label ? "Yes" : "No") + "</div>";
														}
													},
												},
												{
													id: "key",
													header: "Key",
													fillspace: true,
													template: function (obj) {
														if (obj.$level === 1) {
															return "";
														} else {
															return "<div>" + (obj.key ? "Yes" : "No") + "</div>";
														}
													},
												},
												{
													id: "hierarchy",
													header: "Hierarchy",
													fillspace: true,
													template: function (obj) {
														if (obj.$level === 1) {
															return "";
														} else {
															return "<div>" + (obj.hierarchy ? "Yes" : "No") + "</div>";
														}
													},
												},
											],
											data: mappedData,
											on: {
												onBeforeLoad: function () {
													this.showOverlay("Loading...");
												},
												onAfterLoad: function () {
													this.hideOverlay();
												}
											}
										},
										{
											cols: []
										}
									]
								}, {
									cols: []
								}]
							}
						}).show();
					});
				}
			}
			];
		}
		return ui;
	}
}

class CustomExportView extends reports.views["table/export"] {
    GetData = () => {
        let _ = this.app.getService("locale")._;
        return [
            {value: _("To CSV"), id: "csv"},
        ];
    };
}

class CustomCommonView extends reports.views["editor/common"] {
    config() {
        let ui = super.config();
        let add = {
            rows: [
                {view: "label", label: "Roles"},
                {
                    view: "multiselect",
                    localId: "roles",
                    name: "roles",
                    options: []
                },
            ],
        };
        ui.elements.splice(2, 0, add);
        return ui;
    }

    init() {
        super.init();
        let _this = this;
        let roles = this.$$("roles");
        this.app.getService("backend").getRoles().then((res: any) => {
            let opts = res.map((role: any) => {
                return {id: role.id, value: role.name}
            });
            roles.define("options", opts);
            roles.refresh();
        });
        this.SourcesList = this.ui({
            view: "popup",
            body: {
                view: "list",
                scroll: true,
                maxHeight: 500,
                width: 400,
                type: {
                    template: this.JoinTemplate.bind(this),
                },
                click: function (id: any) {
                    let item = _this.SourcesList.getBody().getItem(id);
                    _this.AddJoin(item);
                    _this.SourcesList.hide();
                },
            },
        });
    }

    ShowJoins() {
        let data = this.Local.getLinkedModels([this.State.data].concat(this.State.joins.map(function (a) {
            return a.tid;
        })), false, true);
        let list = this.SourcesList.getBody();
        list.clearAll();
        list.parse(data);
        this.SourcesList.show(this.$$("add").$view);
    };

    JoinTemplate(obj) {
        let s = this.Models[obj.sid];
        let t = this.Models[obj.tid];
        if (obj.id.startsWith(obj.tid)) obj.sf = null;
        let f = obj.sf || obj.tf;
        let n = (obj.sf ? s : t).data.find(function (a) {
            return a.id === f;
        }).name;
        return t.name + " <span class='webix_rpt_sources_path'>" + s.name + (obj.sf ? " (" + n + ")" : "") + " <br /> " + t.name + (obj.tf ? " (" + n + ")" : "") + "</span>";
    };
}

class CustomGridView extends reports.views["modules"] {

	GetListTemplate(item) {
		let _ = this.app.getService("locale")._;
		let html = "<div class='webix_rpt_list_block'>";

		html +=
			"<div class='webix_rpt_list_report_name'>" +
			webix.template.escape(item.name) +
			"</div>";
		html +=
			"<div class='webix_rpt_list_report_date'>" +
			webix.template.escape(item.parsed.desc) +
			"</div>";
		if (!this.State.readonly)
			html +=
				"<span class='webix_icon webix_rpt_action_menu rpi-dots-vertical'></span>";
		return html + "</div>";
	}
}

class CustomToolbarView extends reports.views["table/toolbar"] {
    config() {
        let ui = super.config();
        ui.cols[0].label = "Export Results";
        ui.cols[0].width = 170;
        return ui;
    }
}

class CustomTable extends reports.views["table"] {
    config() {
        let ui = super.config();
        ui.rows.push({
            view: 'pager',
            id: 'pager',
            template: '{common.prev()} {common.next()} Page {common.page()}',
            master: false,
            size: 50,
            group: 5,
            count: 1000,
            on: {
                onItemClick: function (id: any, e: any, node: any) {
                    //@ts-ignore
                    const module = this.$scope.app.getState().module;
                    let offset = module.offset;
                    if (id == 'prev') {
                        if (!offset) {
                            return;
                        }
                        offset -= 50;
                    } else {
                        if (!offset) {
                            offset = 50;
                        } else {
                            offset += 50;
                        }
                    }
                    //@ts-ignore
                    this.$scope.app.getState().module = {...module, limit: 50, offset, updated: true};
                }
            }
        });
        return ui;
    }

    Show(mod: any) {
        let _this = this;
        let host = this.Host;
        if (!mod.updated) {
            if (mod && mod.columns.length && mod.type === "table") {
                if (!mod.limit || !mod.offset) {
                    mod.limit = 50;
                    mod.offset = 0;
                }
                let config = this.GetTableConfig(mod);
                if (!config)
                    return;
                this.Bar.show();
                webix.ui([config], host);
                let table_1 = (this.Table = host.getChildViews()[0]);
                this.GetTableData(mod).then((_a: any) => {
                    let data = _a[0], options = _a[1];
                    if (table_1.$destructed)
                        return;
                    options.forEach(function (_a: any) {
                        let field = _a.field, data = _a.data;
                        if (!_this.IsBucketColumn(field))
                            table_1.getColumnConfig(field).collection.parse(data);
                    });
                    table_1.parse(data);
                    let filters: Map<string, string> = new Map<string, string>();
                    let sorter: any = null;
                    const filterData = () => {
                        let rules = [];
                        for (let [key, value] of filters) {
                            if (value) {
                                //@ts-ignore
                                if (typeof value == 'object' && !value.end && !value.start) { // check if the value is an object and it's not a date range
                                    let selectedValues = Object.keys(value);
                                    let multiselectRule = {
                                        field: key,
                                        type: "text",
                                        glue: "or",
                                        rules: selectedValues.map(item => {
                                            return {
                                                field: key,
                                                type: "text",
                                                condition: {filter: item, type: "equal"},
                                                includes: []
                                            }
                                        }),
                                        includes: []
                                    };
                                    rules.push(multiselectRule);
                                } else if (typeof value == 'object') {
                                    console.log(value)
                                    //@ts-ignore
                                    if (value.start) {
                                        //@ts-ignore
                                        if (value.end) {
                                            rules.push({
                                                field: key,
                                                type: "date",
                                                condition: {filter: value, type: "between"},
                                                includes: []
                                            })
                                        } else {
                                            //@ts-ignore
                                            rules.push({
                                                field: key,
                                                type: "date",
                                                condition: {
                                                    //@ts-ignore
                                                    filter: value.start.toString().substr(0, 10),
                                                    type: "equal"
                                                },
                                                includes: []
                                            })
                                        }
                                    }
                                } else {
                                    rules.push({
                                        field: key,
                                        type: "text",
                                        condition: {filter: value, type: "contains"},
                                        includes: []
                                    })
                                }
                            }
                        }
                        const module = {...this.State.module, query: {glue: "and", rules}, updated: true};
                        this.app.getState().module = module;
                    }
                    const debounceFilter = debounce(() => {
                        filterData()
                    });
                    const sortData = () => {
                        let module;
                        if (sorter) {
                            module = {...this.State.module, sort: [{id: sorter.id, mod: sorter.mod}], updated: true};
                        } else {
                            module = {...this.State.module, sort: null, updated: true};
                        }
                        console.log(module)
                        this.app.getState().module = module;
                    }
                    const debounceSort = debounce(() => {
                        sortData()
                    });
                    table_1.attachEvent("onBeforeFilter", function (column: string, value: string) {
                        filters.set(column, value);
                        debounceFilter();
                        return false;
                    });
                    table_1.data.attachEvent("onBeforeSort", function (by: string, dir: string, as: string) {
                        sorter = {id: by.replace('$text_', ''), mod: dir};
                        debounceSort();
                        return false;
                    })
                });
            } else {
                webix.ui([{}], host);
                this.Table = null;
                this.Bar.hide();
            }
        } else {
            let table_1 = (this.Table = host.getChildViews()[0]);
            table_1.clearAll();
            this.GetTableData(mod).then((_a: any) => {
                let data = _a[0], options = _a[1];
                if (table_1.$destructed)
                    return;
                options.forEach(function (_a: any) {
                    let field = _a.field, data = _a.data;
                    if (!_this.IsBucketColumn(field))
                        table_1.getColumnConfig(field).collection.parse(data);
                });
                table_1.parse(data);
            })
        }
    };

    ready = () => {
        let _this = this;
        let parts = this.getRoot().getChildViews();
        this.Bar = parts[0];
        this.Host = parts[1];
        this.on(this.State.$changes, "module", function (mod: any) {
            return _this.Show(mod);
        });
        this.on(this.app, "exportModule", function (mode: any) {
            return _this.Export(mode);
        });
        this.on(this.LocalState.$changes, "search", function (v: any) {
            return _this.Find(v);
        });
    };
    GetTableConfig = (mod: any) => {
        let _this = this;
        let groups = mod.groups, columns = mod.columns, meta = mod.meta;
        if (!columns)
            return null;
        let dateColumns: any[] = [];
        let gColumns = columns.map(function (a: { type: string; id: any; }) {
            if (a.type == "date")
                dateColumns.push(a.id);
            return _this.GetColumnConfig(a);
        });
        let edit = this.State.mode === "edit";
        let grid = {
            view: groups ? "treetable" : "datatable",
            columns: gColumns,
            resizeColumn: edit ? {headerOnly: true} : false,
            leftSplit: meta.freeze ? meta.freeze : 0,
            css: edit ? "webix_header_border" : "",
            on: {
                onColumnResize: function (id: any, width: any, old: any, byUser: any) {
                    return _this.SetColWidth(id, width, old, byUser);
                },
            },
            scheme: {}
        };
        if (dateColumns.length)
            grid.scheme = {
                $change: function (row: { [x: string]: string | number | Date; }) {
                    return dateColumns.forEach(function (cId) {
                        return (row[cId] = new Date(row[cId]));
                    });
                },
            };
        return grid;
    };
    GetColumnConfig = (a: any) => {
        let column = {
            id: a.id,
            header: [
                a.meta.name || a.name,
                {
                    content: a.type === "dateTime" ? "dateRangeFilter" :
                        a.type === "date" ? "dateRangeFilter" :
                            a.type === "reference" ? "multiSelectFilter" :
                                a.type === "boolean" ? "multiSelectFilter" :
                                    a.type === "picklist" ? "multiSelectFilter" :
                                        a.meta.header === "select" ? "multiSelectFilter" :
                                            "textFilter",
                },
            ],
            type: a.type,
            //@ts-ignore
            sort: typeToSort[a.type],
            width: a.width || 200,
        } as any;

        if (a.type === "dateTime")
            column.template = function (obj: any) {
                return webix.Date.dateToStr("%m/%d/%Y %H:%i:%s")(obj[a.id]);
            }
        if (a.type === "date")
            column.template = function (obj: any) {
                if (obj[a.id] == 'Invalid Date') {
                    return [];
                } else {
                    return dayjs(obj[a.id]).format('YYYY/MM/DD');
                }
            }
        if (a.type === "text") {
            column.template = function (obj: { [x: string]: string; }) {
				if (obj[a.id] == null) {
					return [];
				} else {
					return (obj[a.id] && typeof obj[a.id] === "string" && obj[a.id].startsWith('http') ? `<a href="${obj[a.id]}">${obj[a.id]}</a>` : obj[a.id]);
				}
            };
        }
        if (a.type === "boolean") {
            let _1 = this.app.getService("locale")._;
            column.template = function (obj: { [x: string]: number; }) {
				if (obj[a.id] == null) {
					return [];
				} else {
					return (obj[a.id] == 1 ? _1("True") : _1("False"));
				}
            };
        }
        if ((a.type === "reference" || a.type === "picklist") &&
            !this.IsBucketColumn(a.id))
            column.options = [];
        return column;
    };
    Export = (mode: any) => {
        if (this.Table) {
            let config = JSON.parse(JSON.stringify(this.app.getState().module));
            config.name = this.Local._modules.getItem(config.id).name;
            config.columnNames = config.columns.map((x: any) => x.name);
            config.columns = config.columns.map((x: any) => x.id);
            this.app.webix.alert({text: "<h4>Export has started</h4> You will be notified via email when it is done. You can also check the Exports report to find the link (expires after 24 hours)."})
            this.app.getService("backend").getExport(config);
        }
    };
}

const ReportsManager: React.FC<any> = ({readonly = false, embedded = false}) => {
	const [client, setClient] = useState(localStorage.getItem('currentClient'));
	const {token} = useAuth();
	const clientProp = new URLSearchParams(window.location.search).get("client");
	const getUi = () => {
		let roles = [];
		if (token && jwt_decode(token)) {
			//@ts-ignore
			roles = jwt_decode(token).roles
		}
		return {
			view: "reports",
			id: "reports",
			url: process.env.REACT_APP_REPORTS_ENDPOINT,
			readonly,
			roles,
			//@ts-ignore
			override: new Map([
				[reports.views["table"], CustomTable],
				[reports.views["editor/structure/column"], CustomColumnSetup],
				[reports.services.Backend, MyBackend],
				[reports.services.Local, MyLocal],
				[reports.views["toolbar"], CustomToolbar],
				[reports.views["table/export"], CustomExportView],
				[reports.views["editor/common"], CustomCommonView],
				[reports.views["table/toolbar"], CustomToolbarView],
				[reports.views["modules"], CustomGridView],
			])
		};
	}

	useIonViewDidEnter(() => {
		if (clientProp) {
			localStorage.setItem('currentClient', clientProp);
		}

		webix.extend($$("reports"), webix.ProgressBar);
		$$("reports").showProgress({type: "top"});

		// Anything that needs to reposition
		$$("reports").adjust();
		$$("reports").resize();

	});
	useEffect(() => {
		webix.delay(() => {
			// Anything that needs to reposition
			webix.ui.resize();
		}, 100); // Wait for Ionic layout to settle
	}, []);



	return (
		<IonPage>
			{!embedded && <IonHeader>
				<IonToolbar>
					<IonButtons slot="secondary">
						<IonBackButton icon={arrowBack} text="" className="custom-back"/>
					</IonButtons>
					<IonTitle>Reports Manager</IonTitle>
				</IonToolbar>
			</IonHeader>}
			<IonContent fullscreen>
				<Webix ui={getUi()}/>
			</IonContent>
		</IonPage>
	);
};

export default ReportsManager;
